import { render } from "./InformationView.vue?vue&type=template&id=53c8d9b9"
import script from "./InformationView.vue?vue&type=script&lang=js"
export * from "./InformationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__